/**
 * Utilitários de período de relatório (Design.md §8.4). Período no formato
 * `YYYY-MM` (contrato do backend, apps/api/src/reports.ts). Lógica PURA e
 * determinística — recebe a data de referência, nunca chama `new Date()` por
 * conta própria (testável). Rótulos em pt-BR.
 */
const MONTHS_PT_BR = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
] as const;

const PERIOD_RE = /^(\d{4})-(\d{2})$/;

/** Período do mês da data informada, no formato `YYYY-MM`. */
export function periodFromDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}

export function isValidPeriod(period: string): boolean {
  const match = PERIOD_RE.exec(period);
  if (match === null) {
    return false;
  }
  const month = Number(match[2]);
  return month >= 1 && month <= 12;
}

/** Rótulo pt-BR de um período, ex.: "2026-06" → "Junho de 2026". */
export function formatPeriodLabel(period: string): string {
  const match = PERIOD_RE.exec(period);
  if (match === null) {
    return period;
  }
  const month = Number(match[2]);
  if (month < 1 || month > 12) {
    return period;
  }
  return `${MONTHS_PT_BR[month - 1]} de ${match[1]}`;
}

/** Últimos `count` períodos (mês atual primeiro), p/ o filtro/seleção. */
export function recentPeriods(reference: Date, count: number): string[] {
  const periods: string[] = [];
  const year = reference.getFullYear();
  const month = reference.getMonth(); // 0-based
  for (let i = 0; i < count; i += 1) {
    periods.push(periodFromDate(new Date(year, month - i, 1)));
  }
  return periods;
}
